/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Missing_HintInputs */

const cs_ebr_missing_hint = /** @type {(inputs: Ebr_Missing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky vytvořené importem, které eBrána už neexportuje. Můžete je archivovat (vratné, nic se nemaže).`)
};

const en_ebr_missing_hint = /** @type {(inputs: Ebr_Missing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers created by the import that eBrána no longer exports. You can archive them (reversible, nothing is deleted).`)
};

/**
* | output |
* | --- |
* | "Offers created by the import that eBrána no longer exports. You can archive them (reversible, nothing is deleted)." |
*
* @param {Ebr_Missing_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_missing_hint = /** @type {((inputs?: Ebr_Missing_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Missing_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_missing_hint(inputs)
	return cs_ebr_missing_hint(inputs)
});